const getProgramNameData = (state) => {
  return state.programNameSubscription.data || {};
};

const getIsProgramNameDataLoading = (state) => {
  return state.programNameSubscription.loading;
};

export { getProgramNameData, getIsProgramNameDataLoading };
